module.exports = __webpack_public_path__ + "img/w3_button_close_black.1c590089.1c590089.png";